<template>
  <div class="date-time-input clearfix">
    <div class="form-group row">
      <label :class="options.fullWidth ? 'col-sm-12' : 'col-sm-3 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-9'">
        <object-select-input ref="day" :options="dayOptions" :value="dayValue" @input="validateDay($event)"></object-select-input>
        <object-select-input ref="month" :options="monthOptions" :value="monthValue" @input="validateMonth($event)"></object-select-input>
        <div :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </div>
      </div>
    </div>
    <input type="hidden" :name="options.name" :value="value"/>
  </div>
</template>

<script>
import ObjectSelectInput from '@/components/inputs/ObjectSelectInput'
import {
    validationClass,
    formControlValidationClass,
    validationMessage
  } from '@/util/helpers'

export default {
  name: 'DayAndMonthInput',
  components: {
    ObjectSelectInput
  },
  props: {
    value: {
      type: String
    },
    options: {
      type: Object,
      default () {
        return {
          name: '',
          label: ''
        }
      }
    }
  },
  computed: {
    validationClass,
    formControlValidationClass,
    validationMessage
  },
  data () {
    return {
      isValid: false,
      isDirty: false,
      dayValue: '',
      monthValue: '',
      monthOptions: {
        label: 'Month',
        name: 'month',
        value: '',
        objects: [],
        objectName: 'label',
        fullWidth: true,
        ignoreSort: true
      },
      dayOptions: {
        label: 'Day',
        name: 'day',
        value: '',
        objects: [],
        objectName: 'label',
        fullWidth: true,
        ignoreSort: true
      }
    }
  },
  mounted () {
    let dayObjects = []
    for (let i = 1; i <= 31; i++) {
      dayObjects.push({
        label: i.toString(),
        uuid: i.toString()
      })
    }
    this.dayOptions.objects = dayObjects
    let monthObjects = []
    for (let month of moment.months()) {
      monthObjects.push({
        label: month,
        uuid: month
      })
    }
    this.monthOptions.objects = monthObjects
    if (this.value) {
      this.dayValue = moment(this.value).format('D')
      this.monthValue = moment(this.value).format('MMMM')
    }
  },
  methods: {
    validate (value) {
      if (this.dayValue && this.monthValue) {
        let date = moment(this.dayValue + ' ' + this.monthValue, 'D MMMM')
        if (date.isValid()) {
          this.$emit('input', date)
          this.isValid = true
        } else {
          this.isValid = false
        }
      } else if (this.options.required) {
        this.isValid = false
      } else {
        this.isValid = true
      }
    },
    validateDay (val) {
      this.dayValue = val
      this.validate()
    },
    validateMonth (val) {
      this.monthValue = val
      this.validate()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/DayAndMonthInput.vue